"use strict";

var _interopRequireDefault = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.function.name");

require("core-js/modules/web.dom.iterable");

var _typeof2 = _interopRequireDefault(require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime-corejs2/helpers/typeof"));

var _objectSpread2 = _interopRequireDefault(require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime-corejs2/helpers/objectSpread2"));

var _waves = _interopRequireDefault(require("@/directive/waves"));

var _Pagination = _interopRequireDefault(require("@/components/Pagination"));

var _lang = _interopRequireDefault(require("@/lang"));

var _httpUtils = _interopRequireDefault(require("@/utils/http-utils"));

var _PermissionPage = _interopRequireDefault(require("@/components/Page/PermissionPage"));

var _PermissionSimplePage = _interopRequireDefault(require("@/components/Page/PermissionSimplePage"));

var _vuex = require("vuex");

var _CustomTableColumn = _interopRequireDefault(require("@/mixins/CustomTableColumn"));

var _moment = _interopRequireDefault(require("moment"));

var _dateformart = require("@/utils/dateformart");

var _SummaryPopup = _interopRequireDefault(require("@/components/SummaryPopup"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// waves directive
// secondary package based on el-pagination
// Custom Table Column Mixins (Omega Theme)
var _default = {
  name: 'refundOrder:view',
  mixins: [_CustomTableColumn.default],
  extends: _PermissionPage.default,
  components: {
    Pagination: _Pagination.default,
    PermissionSimplePage: _PermissionSimplePage.default,
    SummaryPopup: _SummaryPopup.default
  },
  directives: {
    waves: _waves.default
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['auditOptions', 'informationOptions', 'orderStateOption', 'currencyTypeOption', 'refundOrderStateOption', 'netwayCodeOption'])),
  data: function data() {
    return {
      controllerPath: "refundOrder",
      dialogFormVisible: false,
      tableKey: 0,
      list: null,
      organizationOption: null,
      agentOption: null,
      channelOption: null,
      total: 0,
      listLoading: true,
      timeList: [],
      queryParameter: {
        pageNum: 1,
        pageSize: 10,
        state: null,
        agentId: '',
        organizationCode: '',
        orderNo: '',
        rechargeOrderNo: ""
      },
      formTemp: {
        id: "",
        orderNo: "",
        msgId: "",
        resMsg: "",
        notifyTime: "",
        notifyProperty: "",
        createTime: ""
      },
      viewSummary: false,
      summaryList: [],
      downloadLoading: false,
      multipleSelection: [],
      netwayCodeEnums: []
    };
  },
  created: function created() {
    this.handleNetwayCode();
    this.setDefaultTime();
    this.getOption();
    this.getList();
  },
  methods: {
    handleNetwayCode: function handleNetwayCode() {
      this.netwayCodeEnums = this.$store.getters.netwayCodeEnums;

      if (this.netwayCodeEnums == null || (0, _typeof2.default)(this.netwayCodeEnums) != 'object' || this.netwayCodeEnums.length < 1) {
        this.netwayCodeEnums = this.netwayCodeOption;
      }
    },
    convertCurrencyCodeToName: function convertCurrencyCodeToName(code) {
      var found = code;
      this.currencyTypeOption.forEach(function (status) {
        if (status.key == code) {
          found = status.display_name;
          return;
        }
      });
      return found;
    },
    convertOrgCodeToName: function convertOrgCodeToName(code) {
      var found = code;
      this.organizationOption.forEach(function (status) {
        if (status.organizationCode == code) {
          found = status.organizationName;
          return;
        }
      });
      return found;
    },
    convertChannelIdToName: function convertChannelIdToName(code) {
      var found = "";
      this.channelOption.forEach(function (status) {
        if (parseInt(status.channelId) == code) {
          found = status.channelName;
          return;
        }
      });
      return found;
    },
    convertAgentIdToName: function convertAgentIdToName(code) {
      var found = "";
      this.agentOption.forEach(function (status) {
        if (parseInt(status.agentId) == code) {
          found = status.agentName;
          return;
        }
      });
      return found;
    },
    setDefaultTime: function setDefaultTime() {
      var a = new Date(Date.now());
      a.setHours(0, 0, 0, 0);
      var b = new Date(Date.now());
      b.setHours(23, 59, 59, 0);
      this.timeList = [this.dateFormat(a), this.dateFormat(b)];
    },
    getList: function getList() {
      var _this = this;

      this.listLoading = true;
      this.viewSummary = false;
      this.summaryList = [];
      var params = this.getQueryParams();

      _httpUtils.default.post(this.controllerPath, "list", null, params).then(function (res) {
        //let index;
        _this.list = res.data.rows;
        _this.total = res.data.total;
      }).finally(function () {
        _this.listLoading = false;
      });
    },
    getOption: function getOption() {
      var _this2 = this;

      if (this.$store.getters.isAdmin) {
        _httpUtils.default.post("agent", "getAgents", null, null).then(function (agent) {
          _this2.agentOption = agent.data;
        }).catch(function (err) {
          _this2.$notify({
            title: _this2.$t("common.error"),
            message: _this2.$t("common.fetchError") + ',' + err.message,
            type: "error"
          });
        });
      }

      _httpUtils.default.post("payChannel", "getPayChannelOption", null, null).then(function (res) {
        _this2.channelOption = res.data;
      }).catch(function (err) {
        _this2.$notify({
          title: _this2.$t("common.error"),
          message: _this2.$t("common.fetchError") + ',' + err.message,
          type: "error"
        });
      });

      _httpUtils.default.post("organization", "getOrgs", null, null).then(function (res) {
        _this2.organizationOption = res.data;
      }).catch(function (err) {
        _this2.$notify({
          title: _this2.$t("common.error"),
          message: _this2.$t("common.fetchError") + ',' + err.message,
          type: "error"
        });
      });
    },
    getQueryParams: function getQueryParams() {
      var startTime, endTime;

      if (!this.timeList) {
        startTime = (0, _dateformart.getYesterday)();
        endTime = (0, _dateformart.getYesterdayEnd)();
      } else {
        startTime = this.timeList[0];
        endTime = this.timeList[1];
      } // if (this.queryParameter.state !== null) {
      //   state = this.queryParameter.state;
      // }


      return {
        pageNum: this.queryParameter.pageNum,
        pageSize: this.queryParameter.pageSize,
        startTime: startTime,
        endTime: endTime,
        state: this.queryParameter.state,
        orderNo: this.queryParameter.orderNo,
        rechargeOrderNo: this.queryParameter.rechargeOrderNo,
        agentId: this.queryParameter.agentId,
        organizationCode: this.queryParameter.organizationCode // sendCode: this.queryParameter.batchNumber,
        // auditState: "1",
        // createUsername: this.queryParameter.submitter

      };
    },
    resetFormTemp: function resetFormTemp() {
      this.formTemp.id = "", this.formTemp.orderNo = "", this.formTemp.msgId = "", this.formTemp.resMsg = "", this.formTemp.notifyTime = "", this.formTemp.notifyProperty = "", this.formTemp.createTime = "", this.dialogFormVisible = false;
    },
    getRowData: function getRowData(row) {
      this.formTemp = {
        id: row.id,
        orderNo: row.orderNo,
        msgId: row.msgId,
        resMsg: row.resMsg,
        notifyTime: row.notifyTime,
        notifyProperty: row.notifyProperty,
        createTime: row.createTime
      };
    },
    handleExportReport: function handleExportReport() {
      var excelName = _lang.default.t("route.refundOrderReport") + ".xlsx";
      var params = this.getQueryParams(); // httpUtils.getByBlob("statisticalChannel", "excel", params, excelName);

      _httpUtils.default.getByBlob("refundOrder", "excel", params, excelName); // MessageBox.confirm(
      //   i18n.t("warningMessage.pleaseWaitForExportAndNavigateMessage"),
      //   i18n.t("warningMessage.pleaseWaitForExportAndNavigateTitle"),
      //   {
      //     confirmButtonText: i18n.t("warningMessage.exportAndNavigateConfirmButtonText"),
      //     cancelButtonText: i18n.t("warningMessage.exportAndNavigateCancelButtonText"),
      //     type: 'warning'
      //   }
      // ).then(() => {
      //   // route to exported excel page
      //   this.$router.push({
      //     name: "exportedExcel:view"
      //   });
      // }).catch(() => null);

    },
    getStatistic: function getStatistic() {
      var _this3 = this;

      var params = this.getQueryParams();

      _httpUtils.default.post("refundOrder", "sum", null, params).then(function (res) {
        var data = res.data;
        _this3.summaryList = [// [{
        //   label: 'SMS.totalText',
        //   value: data.totalCount || 0,
        //   unit: 'SMS.tiao'
        // }]
        [{
          label: 'refundOrderState.receiveSuccess',
          value: data.status1 || 0,
          unit: 'SMS.tiao'
        }, {
          label: 'refundOrderState.receiveFail',
          value: data.status2 || 0,
          unit: 'SMS.tiao'
        }, {
          label: 'refundOrderState.submitSuccess',
          value: data.status3 || 0,
          unit: 'SMS.tiao'
        }, {
          label: 'refundOrderState.submitFail',
          value: data.status4 || 0,
          unit: 'SMS.tiao'
        }, {
          label: 'refundOrderState.refundSuccess',
          value: data.status5 || 0,
          unit: 'SMS.tiao'
        }, {
          label: 'refundOrderState.refundFail',
          value: data.status6 || 0,
          unit: 'SMS.tiao'
        }, {
          label: "refundOrder.refundAmountText",
          value: data.processRefundAmountText || 0,
          unit: 'USD'
        }]];
      }).catch(function (err) {
        _this3.$notify({
          title: _this3.$t("common.error"),
          message: _this3.$t("common.fetchError") + ',' + err.message,
          type: "error"
        });
      }).finally(function () {
        if (_this3.viewSummary == true) {
          _this3.viewSummary = false;
        } else {
          _this3.viewSummary = true;
        }
      });
    },
    handlePresentData: function handlePresentData(row) {
      var _this4 = this;

      this.resetFormTemp();

      _httpUtils.default.post("rechargeOrderNotify", "getNotify", null, row).then(function (res) {
        if (res.data && res.data.length >= 1) {
          _this4.dialogFormVisible = true;

          _this4.getRowData(res.data[0]);
        }
      }).catch(function (err) {
        _this4.$notify({
          title: _this4.$t("common.error"),
          message: _this4.$t("common.fetchError") + ',' + err.message,
          type: "error"
        });
      }); // this.dialogFormVisible = true;

    },
    handleFilter: function handleFilter() {
      this.queryParameter.pageNum = 1;
      this.getList();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    refundStateCodeConvert: function refundStateCodeConvert(state) {
      var found = state;
      this.refundOrderStateOption.forEach(function (status) {
        if (parseInt(status.key) === state) {
          found = status.name;
          return;
        }
      });
      return found;
    },
    convertNetwayCodeToName: function convertNetwayCodeToName(code) {
      var found = code;
      this.netwayCodeEnums.forEach(function (netway) {
        if (netway.key === code) {
          found = netway.display_name;
          return;
        }
      });
      return found;
    },
    dateFormat: function dateFormat(date) {
      if (date == undefined || date == '-') {
        return "-";
      }

      return (0, _moment.default)(date).format("YYYY-MM-DD HH:mm:ss");
    }
  }
};
exports.default = _default;